import { ITrackNewAnalytics } from '../Interfaces/Events';
import { Config } from '../Interfaces/Config';

export default abstract class AbstractSystem {
    public name: string;
    public isInit: boolean;

    constructor(name: string, isInit: boolean) {
        this.name = name;
        this.isInit = isInit;
    }

    abstract init({ id, config }: { id: string; config?: Config }): void;

    abstract trackNew(analyticObj: ITrackNewAnalytics): void;

    public getName = () => {
        return this.name;
    };

    protected getIsInit = () => {
        return this.isInit;
    };
}
